/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventProcessDto } from '../../models/workflow-trigger-event-process-dto';

export interface AutomatedProcessGetAllTriggerEventProcesses$Params {
}

export function automatedProcessGetAllTriggerEventProcesses(http: HttpClient, rootUrl: string, params?: AutomatedProcessGetAllTriggerEventProcesses$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowTriggerEventProcessDto>>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetAllTriggerEventProcesses.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkflowTriggerEventProcessDto>>;
    })
  );
}

automatedProcessGetAllTriggerEventProcesses.PATH = '/automated-process/workflow-trigger/trigger-event-process';